module.exports = __webpack_public_path__ + "img/CreditCard.491a7313.gif";